import React, { useCallback } from 'react'
import styled from 'styled-components'

import { colors } from 'helpers/colors'
import Button from 'components/reusable/button'
import Flex from 'components/reusable/flex'
import Indent from 'components/reusable/indent'
import Text from 'components/reusable/text'
import ApplicationHelper from 'helpers/application_helper'

const Wrapper = styled(Flex)`
  width: 520px;
  padding: 56px 56px 40px;
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
    padding: 24px 16px 16px;
  }
`

const CloseJobToApplicantsModal = ({ onClose, modalProps = {} }) => {
  const { onConfirm } = modalProps

  const handleConfirm = useCallback(() => {
    if (typeof onConfirm === 'function') {
      onConfirm(true)
    }
    onClose()
  }, [onConfirm, onClose])

  const handleCancel = useCallback(() => {
    if (typeof onConfirm === 'function') {
      onConfirm(false)
    }
    onClose()
  }, [onConfirm, onClose])

  return (
    <Wrapper dir="column">
      <Text size={ApplicationHelper.isMobile ? 18 : 24} weight={500}>
        Close job to new applicants?
      </Text>
      <Indent bottom={40} />

      <Text lineHeight="170%">
        This will prevent new applicants from applying to this job. Existing applicants will still be able to continue their applications.
      </Text>
      <Indent bottom={40} />

      <Button type="primary" height={40} width="100%" onClick={handleConfirm}>
        Yes, close job
      </Button>
      <Indent bottom={16} />

      <Button height={40} width="100%" color={colors.gray[600]} borderColor="transparent" onClick={handleCancel}>
        No, keep it open
      </Button>
    </Wrapper>
  )
}

export default CloseJobToApplicantsModal
